import { z } from "zod";

/**
 * Stake tier, orthogonal to the competition `type` (format). `FREE` is the
 * casual no-buy-in tier (no rewards), `PAID` the classic buy-in duel (winner
 * takes the pot), `SPIN_AND_GO` the buy-in duel whose prize pool is resized by a
 * drawn pot multiplier, `ONBOARDING` the retired server-side first-time-user
 * duel (never user-selectable; no new entries — a FREE pick while
 * onboarding-eligible opens the client-side practice duel, configured by this
 * tier's row). Paid tiers carry a
 * CMS-configured buy-in list ({@link ArenaBuyInOptionDtoSchema}); the client
 * picks one of the tier's enabled amounts at opt-in.
 */
export const ArenaEntryTierSchema = z.enum(["FREE", "PAID", "SPIN_AND_GO", "ONBOARDING"]);
export type ArenaEntryTierDto = z.infer<typeof ArenaEntryTierSchema>;
